<div *ngFor="let header of headers()">
  <h3 [innerHTML]="header | sanitizeHtml"></h3>
</div>
<div class="uk-flex uk-flex-middle uk-flex-column ">
  <div class="uk-margin-bottom">
    <div [innerHTML]="body | sanitizeHtml"></div>
  </div>

  <div class="uk-margin-top">
    <button type="submit"
      class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
      [ngStyle]="{'background-color': getPrimaryColor()}"
      (click)="onOk()">{{btnOk()}}
    </button>
    <!-- <div class="uk-margin-top">
      <a class="uk-text-meta uk-margin-small-right" (click)="redirectToChateRoom()"><u>กลับไปยังห้องสนทนา</u></a>
    </div> -->
  </div>
</div>

<!-- <div>
  <div *ngFor="let header of headers">
    <div class="uk-flex uk-flex-center uk-text-bold uk-text-secondary uk-text-large"
      
  </div>

  <div class="uk-flex uk-flex-column uk-flex-center">
    <div class="uk-text uk-text-secondary " [innerHTML]="body | sanitizeHtml"></div>
  </div>
</div> -->
<!-- <div>
    <div class="uk-flex uk-flex-column uk-flex-center">
      <div class="uk-text">{{ description }}</div>
      <h4>
        <a class="uk-link-text uk-text-primary" uk-icon="icon: link" (click)="onError()">กลับไปยังห้องสนทนา</a>
      </h4>
      <div style="margin-top: 60%;color: #efefef">error code : {{ code }}</div>
    </div>
  </div> -->
<!-- <div *ngIf="isShowButton">
  <div class="uk-margin-large-top">
    <button class="uk-button uk-button-primary uk-border-rounded" (click)="onOk()">{{btnOk}}</button>
  </div>
</div> -->